import { cn } from '@/lib/utils';
import type { WorkItemStatus, PlanStatus } from '../types/models';

// Inline Tailwind classes per status — keeps the colour mapping deterministic
// across the app. Both WorkItemStatus and PlanStatus share the table; statuses
// that don't appear (e.g. weird future enum values) fall back to "Backlog".
const STATUS_CLASSES: Record<string, string> = {
  Backlog: 'bg-slate-500/15 text-slate-500 dark:text-slate-300',
  Planned: 'bg-blue-500/15 text-blue-600 dark:text-blue-300',
  InProgress: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  Done: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-300',
  Deferred: 'bg-slate-500/15 text-slate-500 dark:text-slate-300',
  Cancelled: 'bg-rose-500/15 text-rose-600 dark:text-rose-300',
  Draft: 'bg-slate-500/15 text-slate-500 dark:text-slate-300',
  Proposed: 'bg-blue-500/15 text-blue-600 dark:text-blue-300',
  Approved: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-300',
  Active: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  Adjusted: 'bg-orange-500/15 text-orange-600 dark:text-orange-300',
  Closed: 'bg-slate-500/15 text-slate-500 dark:text-slate-300',
};

export default function StatusChip({ status }: { status: WorkItemStatus | PlanStatus }) {
  const classes = STATUS_CLASSES[status] ?? STATUS_CLASSES.Backlog;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold leading-none',
        classes,
      )}
    >
      {status.replace(/([A-Z])/g, ' $1').trim()}
    </span>
  );
}
